module.exports = __webpack_public_path__ + "img/la.2a16c054.jpg";